import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { LicensePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface LicenseProductCategoryModel {
    licenseId: number
    itemTypeId: number
    productCategoryId: number
    included: boolean
    excluded: boolean
}

const AddProductCategoryPopup: React.FC<LicensePopupProps> = ({ show, onHide, licenseId, included }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<LicenseProductCategoryModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<LicenseProductCategoryModel>({
        licenseId: licenseId,
        itemTypeId: 0,
        productCategoryId: 0,
        included: included,
        excluded: !included
    });

    const itemTypes = useSelectListOptions('api/v1/selectlist/ItemTypes', '-- Select item type')
    const categories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTreeLeaves?activeOnly=true&itemTypeId=' + formData.itemTypeId, '-- Select category')

    useEffect(() => {
        formData.included = included;
        formData.excluded = !included;
        setFormData(formData);

    }, [included]);

    function submit() {
        if (formData) {
            DataService
                .create<LicenseProductCategoryModel>(`api/v1/LicenseProductCategories`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'itemTypeId', label: 'Item type', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'productCategoryId', label: 'Category', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={included ? 'Include category in License' : 'Exclude category from License'}>
            <Popup.Body>
                <SelectListField {...getFieldProps('itemTypeId')} options={itemTypes} />
                <SelectListField {...getFieldProps('productCategoryId')} options={categories} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProductCategoryPopup;